import ReButton from '@/elements/ReButton.vue'
import ReCheckbox from '@/elements/ReCheckbox.vue'
import ReField from '@/elements/ReField.vue'
import ReInput from '@/elements/ReInput.vue'
import ReStepperInput from '@/elements/ReStepperInput.vue'
import ReSelect from '@/elements/ReSelect.vue'
import ReTooltip from '@/elements/ReTooltip.vue'
import ReIcon from '@/elements/ReIcon.vue'
import ReTitle from '@/elements/ReTitle.vue'
import ReMultiChoice from '@/elements/ReMultiChoice.vue'
import ReDateTimePicker from '@/elements/ReDateTimePicker.vue'
import RePage from '@/elements/RePage.vue'
import ReDialog from '@/elements/ReDialog.vue'
import ReBanner from '@/elements/ReBanner.vue'
import ReLoading from '@/elements/ReLoading.vue'
import ReSlider from '@/elements/ReSlider.vue'
import ReForm from '@/elements/ReForm.vue'
import ReStatic from '@/elements/ReStatic.vue'
import ReBadge from '@/elements/ReBadge.vue'
import ReAvatar from '@/elements/ReAvatar.vue'
import ReDrawer from '@/elements/ReDrawer.vue'

const ReLibrary = {
  install(app) {
    app.component('ReButton', ReButton)
    app.component('ReCheckbox', ReCheckbox)
    app.component('ReField', ReField)
    app.component('ReInput', ReInput)
    app.component('ReStepperInput', ReStepperInput)
    app.component('ReSelect', ReSelect)
    app.component('ReTooltip', ReTooltip)
    app.component('ReIcon', ReIcon)
    app.component('ReAvatar', ReAvatar)
    app.component('ReTitle', ReTitle)
    app.component('ReMultiChoice', ReMultiChoice)
    app.component('ReDateTimePicker', ReDateTimePicker)
    app.component('RePage', RePage)
    app.component('ReDialog', ReDialog)
    app.component('ReBanner', ReBanner)
    app.component('ReLoading', ReLoading)
    app.component('ReForm', ReForm)
    app.component('ReSlider', ReSlider)
    app.component('ReStatic', ReStatic)
    app.component('ReBadge', ReBadge)
    app.component('ReDrawer', ReDrawer)
  },
}

export default ReLibrary
